import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introfsk() {
  return (
    <div className="intro_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="resp_order">
            <div className="intro-img-fsk">
              <StaticImage
                src="../../../images/case-studies/fsk/intro-ground.webp"
                alt="TekRevol"
                className="logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={963}
                height={560}
              />
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="">
            <div className="intro-fsk-content">
              <h2>
                Introduction <span>FSK</span>
              </h2>
              <p>
                "FSK"redefines mobile gaming by seamlessly blending match-3
                puzzles, time managementchallenges, and role-playing elements.
                Players embark on a culinary adventure,building a restaurant
                empire, and applying real-time market strategies to crafttheir
                success.
              </p>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2} className="resp_order_1">
            <div className="intro-clock-img">
              <StaticImage
                src="../../../images/case-studies/fsk/intro-clock.webp"
                alt="TekRevol"
                className="logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={240}
                height={504}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Introfsk;
